import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input, OnChanges,
  OnInit,
  Output, SimpleChanges
} from '@angular/core';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';
import {SchedulingService} from '../../../modules/scheduling/scheduling.service';
import {DoctorsService} from '../../../services/doctors.service';
import {DoctorDataModel} from '../../../models/doctors/doctor-data.model';
import {DataAppointmentModel} from '../../../models/appointments/data-appointment.model';
import {PatientService} from '../../../modules/patient/patient.service';
import {PatientDataModel} from '../../../models/patient/patient-data.model';
import {cfgCaseProcedure4Procedure} from '../../../modules/procedure/creation/procedure-creation.models';
import {ProcedureService} from '../../../modules/procedure/procedure-service';
import {OfficeLocationsService} from '../../../modules/configuration/office-locations/office-locations.service';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {ProceduresService} from '../../../modules/configuration/procedures/procedures.service';
import {NoteDataModel} from '../../../models/notes/note-data.model';
import {NotesService} from '../../../services/notes.service';
import {NoteGroupDataModel} from '../../../models/notes/note-group-data.model';
import {TdoNoteQueryModel} from '../../controls/tdo-notes/models/tdo-note-query.model';
import {DailyDetailModel} from '../../../models/appointments/daily-detail.model';
import {FileManagerService} from '../../../modules/file-manager/file-manager.service';
import {Globals} from '../../../globals';
import {DailyDetailAppointmentModel} from '../../../models/appointments/daily-detail-appointment.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {PatientFlagDataModel} from '../../../models/patient/patient-flag-data.model';
import {AppointmentFlagDataModel} from '../../../models/appointments/appointment-flag-data.model';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {MessagingService} from '../../../services/messaging.service';
import {Router} from '@angular/router';
import {UiService} from '../../../services/ui.service';
import {WeeklyDetailDataModel} from '../../../models/appointments/weekly-detail-data.model';

// tslint:disable-next-line:class-name
interface appDisplay {
  appInfo: DataAppointmentModel;
  patInfo: PatientDataModel;
  docInfo: DoctorDataModel;
  proInfo: cfgCaseProcedure4Procedure;
  noteInfo: NoteDataModel[];
}

@Component({
  selector: 'app-day-detail-view',
  templateUrl: './day-detail-view.component.html',
  styleUrls: ['./day-detail-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DayDetailViewComponent implements OnInit, OnChanges {
  @Input() selectedDate: Date;
  @Input() selectedDoctors: DoctorDataModel[];
  @Output() viewTypeChange: EventEmitter<string> = new EventEmitter<string>();

  viewType: string = 'dayDetailView';
  slots: Date[] = [];
  currentLOCID: string;
  selectedOperatories: any[] = [];
  selectedOperatoryData: OperatoryDataModel[];
  // selectedDate: Date;
  dateRange: string = '';
  patient: PatientDataModel;
  patients: PatientDataModel[] = [];
  doctors: DoctorDataModel[] = [];
  doctor: DoctorDataModel;
  selectedDoctor: DoctorDataModel;
  times: DataAppointmentModel[] = [];
  appointment: DataAppointmentModel;
  selectedAppointment: DataAppointmentModel;
  appointments: DataAppointmentModel[] = [];
  currentAppointments: DataAppointmentModel[] = [];
  appDisplays: appDisplay[] = [];
  selectedTime: string;
  procedure: cfgCaseProcedure4Procedure;
  procedures: cfgCaseProcedure4Procedure[] = [];
  office: ClientLocationDataModel;
  offices: ClientLocationDataModel[] = [];
  patientInfo: string;
  expanded: boolean = false;
  noteGroups: NoteGroupDataModel[] = [];
  notes: NoteDataModel[] = [];
  note: NoteDataModel;
  panelOpenState: boolean = false;
  isLoading = true;

  detailData: DailyDetailModel;
  weeklyData: WeeklyDetailDataModel;
  procedureTypes: EnumValidValueItemModel[] = [];
  patientFlags: EnumValidValueItemModel[] = [];
  appointmentFlags: EnumValidValueItemModel[] = [];
  weeklyAreas: any;
  isWeeklyLoading: boolean = false;

  constructor(private schedulingService: SchedulingService, private doctorsService: DoctorsService,
              private fileService: FileManagerService, private globals: Globals, private cd: ChangeDetectorRef,
              private patientService: PatientService, private procedureService: ProcedureService,
              private locationService: OfficeLocationsService, private proceduresService: ProceduresService,
              private noteService: NotesService, private staticDataService: StaticDataService,
              private messagingService: MessagingService, private router: Router, private uiService: UiService)
  {
    // this.loadPatients();
  }

  async ngOnInit(): Promise<void> {
    this.viewType = 'dayDetailView';
    this.currentLOCID = localStorage.getItem('LOCID');
    this.dateRange = this.formatDate(this.selectedDate) + ' ' + this.formatDate(this.selectedDate);

    if (this.staticDataService.isReady) {
      this.handleEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.handleEnums();
        }
      });
    }
    this.doctorsService.getDoctors().subscribe((docData) => {
      this.doctors = docData;
    });

    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.selectedDate.firstChange) {
      this.loadData();
    }

    if (!changes.selectedDoctors.firstChange) {
      this.loadData();
    }
  }

  loadData() {
    this.isWeeklyLoading = true;
    const appointmentSearchDateRange = this.formatDate(this.selectedDate) + ' ' + this.formatDate(this.selectedDate);
    this.schedulingService.getDailyDetail(appointmentSearchDateRange, this.selectedDoctors.map(p => p.DoctorId), [this.currentLOCID]).subscribe((appRes) => {
      this.detailData = appRes;
      this.cd.markForCheck();

      this.schedulingService.getWeeklyDetail(this.formatDate(this.selectedDate), this.selectedDoctors.map(p => p.DoctorId), [this.currentLOCID]).subscribe((weekRes) => {
        this.isWeeklyLoading = false;
        this.weeklyData = weekRes;
        this.cd.markForCheck();

        this.weeklyAreas = [];
        const perc = weekRes.wtdIntakeEstimate / weekRes.WeeklyIntakeEstimate * 100;
        const perc2 = 100 - perc;
        this.weeklyAreas.push({name: 'wtd', area: perc});
        this.weeklyAreas.push({name: 'all', area: perc2});
      });
    });
  }

  handleEnums() {
    this.procedureTypes = this.staticDataService.getValidValueItemsByValidValueName('enumProcedureType');
    this.patientFlags = this.staticDataService.getValidValueItemsByValidValueName('enumPatientFlag');
    this.appointmentFlags = this.staticDataService.getValidValueItemsByValidValueName('enumAppoitmentFlag');

    this.cd.markForCheck();
  }

  loadAppointments(dateRange: string) {
    this.currentAppointments = [];
    this.schedulingService.getAppointments([this.currentLOCID], dateRange).subscribe(dataC => {
      this.appointments = dataC;
      // tslint:disable-next-line:prefer-for-of no-shadowed-variable
      for (let i = 0; i < this.appointments.length; i++) {
        this.appointment = this.appointments[i];
        this.slots.push(new Date(this.appointment.StartDate));
        // this.loadPatient(this.appointment);
        if (this.selectedDoctor && this.appointment.Label_DoctorId === this.selectedDoctor.DoctorId) {
          this.currentAppointments.push(this.appointment);
          this.loadNotes(this.appointment);
        } else if (this.selectedDoctor && this.appointment.Label_DoctorId === this.selectedDoctor.DoctorId &&
          new Date(this.appointment.StartDate).getHours().toString() === this.selectedTime) {
          this.currentAppointments.push(this.appointment);
          // this.loadPatient(this.appointment);
          this.loadNotes(this.appointment);
        }
        // else if (!this.selectedDoctor && this.appointment.StartDate.getHours().toString() === this.selectedTime) {
        //   this.currentAppointments.push(this.appointment);
        //   this.loadNotes(this.appointment);
        //   this.slots.push(this.appointment.StartDate);
        // }
      }
      // this.loadPatients();
      console.log(this.patients);
    });
    // this.loadPatients();
  }

  loadNotes(appointment: DataAppointmentModel) {
    const noteQuery = new TdoNoteQueryModel();
    noteQuery.patientId = appointment.PatientId;
    noteQuery.parentObjectName = appointment.PatientCaseId;
    noteQuery.objectId = appointment.NoteGroupId;

    let newNotes: NoteDataModel[] = [];
    this.noteService.getNotes(noteQuery).subscribe(noteData => {
      newNotes = noteData;
      console.log(this.notes);
    });
    this.notes.concat(newNotes);
    return newNotes;
  }

  /*loadPatient(appointment: DataAppointmentModel) {
      this.patientService.getPatient(appointment.PatientId).subscribe(patData => {
        this.patient = patData;
      });
      return this.patient;
      this.patients.push(this.patient);
  }

  loadDoctorAppointments(doctor: DoctorDataModel) {
    this.selectedDoctor = doctor;
    this.loadAppointments(this.dateRange);
  }

  deselectDoctor() {
    this.selectedDoctor = null;
    this.loadAppointments(this.dateRange);
  }

  selectAppointment(appointment) {
      if (this.selectedAppointment === appointment) {
        this.selectedAppointment = null;

      } else {
        this.selectedAppointment = appointment;
      }

  }

  deleteAppointment(appointment) {
    if (window.confirm('Are sure you want to delete this appointment ?')){
      appointment.xauditDeleted = true;
      this.appointments.splice(appointment);
    }
  }*/

  // selectTime(slot: string) {
  //   this.selectedTime = slot;
  //   this.loadAppointments(this.dateRange);
  // }

  onSelectedDateChange(date: Date) {
    console.log('Date: ' + date.getMonth() + '/' + date.getDate() + '/' + date.getUTCFullYear());
    this.selectedDate = date;
    this.dateRange = this.formatDate(this.selectedDate) + ' ' + this.formatDate(this.selectedDate);
    this.loadAppointments(this.dateRange);
  }

  onSelectedTimeChange(slot) {
    this.appointments = this.appointments.filter(e => e.StartDate === slot);
  }

  isItemSelected(type: string): boolean {
    return type === this.viewType;
  }
  // noinspection DuplicatedCode
  formatDate(date) {
    // tslint:disable-next-line:one-variable-per-declaration prefer-const
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      // tslint:disable-next-line:prefer-const
      year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  formatDateAndTime(date) {
    // tslint:disable-next-line:one-variable-per-declaration prefer-const
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      // tslint:disable-next-line:prefer-const
      year = '' + d.getFullYear(),
      hour = '' + d.getHours(),
      minutes = '' + d.getMinutes();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    if (hour.length < 2) {
      hour = '0' + hour;
    }
    if (minutes.length < 2) {
      minutes = '0' + minutes;
    }
    return [year, month, day, hour, minutes].join('-');
  }

  /*getPatientPicture(PatientId: string) {
    this.fileService.getPatientPicture(this.globals.currentPatient).subscribe((res) => {
      if (res) {
        this.patientPictureSrc = this.fileService.getDocumentUrlFromDocument(res);
      } else {
        this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
      }
    });
  }*/
  getPatientPicture(d: DailyDetailAppointmentModel) {
    if (!d.PatientPictureDocumentFileName) {
      this.fileService.getPatientPicture(d.PatientId).subscribe((res) => {
        if (res) {
          d.PatientPictureDocumentFileName = this.fileService.getDocumentUrlFromDocument(res);
        } else {
          d.PatientPictureDocumentFileName = 'assets/Images/defaultPatient.PNG';
        }
        this.cd.markForCheck();
        return d.PatientPictureDocumentFileName;
      });
    } else {
      this.cd.markForCheck();
      return d.PatientPictureDocumentFileName;
    }
  }

  getProcedureType(ProcedureType: string) {
    const enu = this.procedureTypes.find(p => p.ValidValueItemId.toLowerCase() === ProcedureType?.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    } else {
      return '';
    }
  }

  getPatientFlag(flag: PatientFlagDataModel) {
    const enu = this.patientFlags.find(p => p.ValidValueItemId.toLowerCase() === flag?.enumPatientFlagID?.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    }

    return '';
  }

  getAppointmentFlag(flag: AppointmentFlagDataModel) {
    const enu = this.appointmentFlags.find(p => p.ValidValueItemId.toLowerCase() === flag?.enumAppoitmentFlagID?.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    }

    return '';
  }

  changeToPatientAndGotoCaseView(appointmentData: DailyDetailAppointmentModel) {
    const patientName = appointmentData.PatientName;

    this.messagingService.componentMessageCall.subscribe((response) => {
      const event = response.event;
      const eventData = response.data;

      switch (event) {
        case MessagingConstants.PATIENT_LOADED:
          this.router.navigateByUrl('/landing/case-view');
          break;
      }
    });

    this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
      PatientID: appointmentData.PatientId,
      PatientName: patientName,
      clearCurrentQuery: false
    });
  }

  openPatientNotes(app: DailyDetailAppointmentModel) {
    this.uiService.openNotesWindow(app.PatientId, app.PatientCaseId);
  }

  getDocument(d: DailyDetailAppointmentModel, id: string) {
    return this.fileService.getDocumentImageUrl(d.PatientId, id);
  }

  updateDoctors(selectedDocs: DoctorDataModel[]) {
    this.selectedDoctors = selectedDocs;
    this.loadData();
  }
}
